(() => {
  if (window.mhDockDeliveryStylesInitialized) return;
  window.mhDockDeliveryStylesInitialized = true;

  const watchedRoots = new WeakSet();
  const deliveryStyles = `
    .sp-delivery {
      font-size: 14px !important;
      color: #18619c !important;
      font-weight: 600 !important;
      line-height: 1.5 !important;
    }
  `;

  function applyStyles() {
    document.querySelectorAll('solopress-configurator').forEach(widget => {
      const root = widget.shadowRoot;
      if (!root || watchedRoots.has(root)) return;
      watchedRoots.add(root);

      function addStyle() {
        if (root.querySelector('#mh-delivery-style')) return;

        const style = document.createElement('style');
        style.id = 'mh-delivery-style';
        style.textContent = deliveryStyles;
        root.appendChild(style);
      }

      addStyle();
      new MutationObserver(addStyle).observe(root, {
        childList: true,
        subtree: true
      });
    });
  }

  customElements.whenDefined('solopress-configurator').then(() => {
    applyStyles();
    new MutationObserver(applyStyles).observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();
